export const TASK_EDITOR_ENABLE_CUSTOM_FIELDS = false;
export const TASK_EDITOR_ENABLE_CLIENT_MESSAGE = false;
export const TASK_EDITOR_ENABLE_SERVICES_CREATION = false;
